// extracted by mini-css-extract-plugin
export var btnBlock = "ArticleButton-module--btnBlock--3jE8U";
export var btnPrimary = "ArticleButton-module--btnPrimary--jUUb4";
export var btnSecondary = "ArticleButton-module--btnSecondary--1mXey";